import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import moment from 'moment';
import { UserContextProvider } from '../../../../../infrastructure/context/user-context-provider';
import { formatCurrencyString } from '../../../../../utilities/CurrencyUtility';

@Component({
  selector: 'app-claim-payment-received-dialog',
  templateUrl: './claim-payment-received-dialog.component.html',
  styleUrls: ['./claim-payment-received-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    ReactiveFormsModule, 
    MatFormFieldModule,
    MatDatepickerModule, 
    MatIcon,
    MatDialogModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class ClaimPaymentReceivedDialogComponent implements OnInit {

  form!: FormGroup;
  currencySymbol!: string;
  formatCurrencyString = formatCurrencyString;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ClaimPaymentReceivedDialogComponent>,
    private formBuilder: FormBuilder,
    private userContextProvider: UserContextProvider
  ) { }

  ngOnInit() {
    this.initForm();

    if (this.data) {
      this.populateForm();
      this.currencySymbol = this.userContextProvider.currencyCode;
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      received_date: ['', Validators.required],
      actual_amount: ['', Validators.required]
    });
  }

  populateForm() {
    this.form.get('received_date')?.setValue(new Date());
    this.form.get('actual_amount')?.setValue(this.data.actual_amount);
  }

  submitClaimPayment() {
    let payload = {
      id: this.data.id,
      actual_amount: this.form.get('actual_amount')?.value,
      status_date: moment(this.form.get('received_date')?.value).format('ll'),
      status_id: this.data.status_id
    }
    this.dialogRef.close(payload);
  }

  canCreateClaimPayment(): boolean {
    return (
      this.form.valid
    );
  }
}